<template>
  <div class="company-option">
    <div class="left">
      <div>
        <p style="text-align: left; margin: 4px;">{{ companyTips }}</p>
        <el-input v-model="companyName"></el-input>
        <el-button size="mini" style="margin: 4px;" type="primary" @click="sure">确定</el-button>
      </div>
      <div>
        <select v-if="listType.length > 1" size="medium" v-model="typeChange" @change="changeType(typeChange)">
          <option v-for="(item, index) in listType" :key="index" :label="item.label" :value="item.value"></option>
        </select>
      </div>
      <div class="upload-main">
        <div class="el-upload el-upload--text" @dragover="fileDragover" @drop="fileDrop">
          <div class="el-upload-dragger">
            <template v-if="!fileName">
              <label for="fileInput"><i class="el-icon-upload"></i></label>
            </template>
            <template v-else>
              <span class="file-name">{{fileName}}</span>
            </template>
            <label class="el-upload__text" for="fileInput">
              将附件拖到此处，或
              <br>
              <em>点击选择</em>
              <br>
              <!-- <span style="font-size: 12px;">excel\word\zip\pdf格式</span> -->
            </label>
          </div>
          <input
            id="fileInput"
            type="file"
            name="file"
            :accept="acceptList"
            @change="chooseUploadFile"
            class="el-upload__input">
        </div>
      </div>
      <div class="upload-action">
        <el-button type="primary" @click="closeIt" size="mini">{{'关闭'}}</el-button>
        <el-button type="primary" @click="upload" size="mini">{{btnName || '上传'}}</el-button>
      </div>
      <uploadFilePage :percent="percent" @cancel="handleCancel"></uploadFilePage>
    </div>
    <div class="right">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="10%">序号</th>
          <th class="cell thtitle">文件名称</th>
          <th class="cell thtitle" width="10%">操作</th>
        </tr>
        <tr v-for="(item, index) in fileList" :key="index">
          <td class="cell tdcell" width="10%">{{ index + 1 }}</td>
          <td class="cell tdcell"><u @click="downloadFile(item.url)">{{ item.name }}</u></td>
          <td class="cell tdcell" width="10%"><u @click="deleteFile(item.id)">删除</u></td>
        </tr>
        <tr v-if="!fileList.length">
          <td class="cell tdcell" width="10%"></td>
          <td class="cell tdcell">暂无文件</td>
          <td class="cell tdcell" width="10%"></td>
        </tr>
      </table>
    </div>
    <nut-dialog
      @close="jindu = false"
      v-if="jindu"
      :visible="jindu"
      title="上传进度"
      :noFooter="true">
      <progress :value="percentage" max="100"></progress>{{ percentage }}%
      <p>{{ text1 }}</p>
      <!-- <progress v-if="jiexiFlsg" :value="percentageA" max="100"></progress><span v-if="jiexiFlsg">{{ percentageA }}%</span>
      <p>{{ text2 }}</p> -->
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../api/index'
import uploadFilePage from '../pages/uploadFilePage'
import axios from 'axios'
export default {
  props: ['uploadMethod', 'btnName', 'acceptList', 'extaParam', 'fileSize', 'overSizeTip'],
  data () {
    return {
      fileName: '',
      percent: 0,
      jindu: false,
      percentage: 0,
      percentageA: 0,
      text1: '',
      text2: '',
      jiexiFlsg: false,
      companyName: '',
      companyTips: '',
      fileList: [],
      typeChange: 0,
      listType: [{
        label: '个人知识库',
        value: 3
      }, {
        label: '公司知识库',
        value: 0
      }]
    }
  },
  mounted () {
    api.remarks({
      type: 202
    }).then(res => {
      this.companyTips = res.data.list[0].subscribe
    })
    api.getUserInfo({
    }).then(res => {
      console.log(res)
      this.companyName = res.data.companyType
    })
    this.getFileList()
  },
  methods: {
    // 完善公司名称
    sure () {
      api.companyNameAdd({
        companyName: this.companyName
      }).then(res => {
        console.log(res)
        if (res.code === 200) {
          api.getUserInfo({
          }).then(res => {
            console.log(res)
            this.companyName = res.data.companyType
          })
        }
        var remarks240BConfirm = confirm(res.message)
        if (remarks240BConfirm) {}
      })
    },
    // 拖拽上传
    fileDragover (e) {
      e.preventDefault()
    },
    fileDrop (e) {
      e.preventDefault()
      const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
    },
    chooseUploadFile (e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
      e.target.value = ''
    },
    upload () {
      if (!this.fileName) {
        this.$toast.text('请选择上传文件')
        return
      }
      this.$emit('beforeUpload')
    },
    closeIt () {
      this.$emit('closeIF')
    },
    doUpload () {
      this.jiexiFlsg = false
      this.text1 = ''
      this.text2 = ''
      // var idJ = 0
      this.percentage = 0
      this.percentageA = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 1
        if (this.percentage >= 98) {
          clearInterval(bianliang)
        }
      }, 500)
      console.log(this.extaParam, 'extaParam')
      console.log(this.uploadMethod, 'uploadMethod')
      this.CancelToken = axios.CancelToken
      this.source = this.CancelToken.source()
      // this.loading = this.$loading()
      api[this.uploadMethod](Object.assign({}, {
        multipartFile: this.batchFile
      }, this.extaParam), (percent) => {
        this.percent = percent
      }, this.source.token).then(res => {
        // this.loading && this.loading.close()
        if (res.code === 200) {
          this.percentage = 100
          this.getFileList()
          clearInterval(bianliang)
          this.text1 = res.message
          setTimeout(() => {
            this.jindu = false
          }, 1000)
          // idJ = res.data
          this.percentageA = 0
          this.$emit('uploadSuccess', res.data)
        } else {
          this.$toast.text(res.message || '上传失败')
        }
      })
    },
    handleCancel () {
      setTimeout(() => {
        this.percent = 0
      }, 100)
      this.source.cancel('Operation canceled by the user.')
    },
    changeType (value) {
      api.cdAshKetchupZskwjEnquiry({
        type: value,
        pages: 100,
        pageNo: 1
      }).then(res => {
        if (res.code === 200) {
          this.fileList = res.data.list
        } else {
          this.$toast.text(res.message)
        }
      })
    },
    getFileList () {
      api.cdAshKetchupZskwjEnquiry({
        type: 0,
        pages: 100,
        pageNo: 1
      }).then(res => {
        if (res.code === 200) {
          this.fileList = res.data.list
        } else {
          this.$toast.text(res.message)
        }
      })
    },
    downloadFile (url) {
      window.open(url)
    },
    deleteFile (id) {
      api.cdAshKetchupZskwjDelete({ id: id }).then(res => {
        if (res.code === 200) {
          this.$toast.text(res.message)
          this.getFileList()
        } else {
          this.$toast.text(res.message)
        }
      })
    }
  },
  components: {
    uploadFilePage
  }
}
</script>

<style lang="scss">
.company-option {
  width: 100%;
  display: flex;
  height: 400px;
  .left {
    width: 300px;
    margin-right: 8px;
    .upload-main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .el-upload--text {
        text-align: center;
        width: 140px;
      }
      .el-upload-right {
        flex: 0;
        .el-form-item {
          margin-bottom: 0;
        }
        .el-cascader {
          margin-bottom: 0!important;
        }
        .el-form-item__error {
          padding-top: 0;
          top: 40px;
        }
        .el-date-editor.el-input {
          width: 172px;
          margin-bottom: 12px;
        }
        .el-select, .el-cascader {
          margin-bottom: 12px;
        }
      }
      .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 140px;
        height: 140px;
      }
      .el-icon-upload {
        margin: 0;
      }
      label {
        display: block;
      }
    }
    .upload-action {
      margin-top: 20px;
      text-align: center;
    }
  }
  .right {
    width: calc(100% - 300px);
    margin-left: 8px;
    height: 100%;
    overflow: auto;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      u {
        color: #00C;
      }
    }
  }
}
</style>
